import { render, staticRenderFns } from "./Gk.vue?vue&type=template&id=36fa75bf&scoped=true"
import script from "./Gk.vue?vue&type=script&lang=js"
export * from "./Gk.vue?vue&type=script&lang=js"
import style0 from "./Gk.vue?vue&type=style&index=0&id=36fa75bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fa75bf",
  null
  
)

export default component.exports